import { EM_DASH } from '~/common/constants/unicode';
import { parseDate } from '~/eds/src/utils/parseDate';
import { DataFieldType } from '~/enums/DataFieldType';
import type { useFormatDateReturnType } from '~/i18n/hooks/useFormatDate/types';
import type { useFormatNumberReturnType } from '~/i18n/hooks/useFormatNumber/types';
import { Nullable } from '~/types/Nullable';
import { getUniqueFieldValues } from '~/utils/document.utils';
import { capitalizeWords } from '~/utils/strings';

import { Field, FieldValue } from './types/fields';

export const isWssField = (field: Field): boolean => field.source === 'wss';

export const getFieldDisplayValue = (
  type: DataFieldType,
  value: Nullable<FieldValue | FieldValue[]>,
  formatDate: useFormatDateReturnType,
  formatNumber: useFormatNumberReturnType,
) => {
  if (!value) return EM_DASH;

  switch (type) {
    case DataFieldType.ARRAY_MULTIPLE:
    case DataFieldType.ATTACHMENT:
      if (!(value as FieldValue[]).length) return EM_DASH;
      return getUniqueFieldValues(value as FieldValue[])
        .map((val) => `- ${val.displayValue}`)
        .join('\n');

    case DataFieldType.DATE:
      const dateValue = (value as FieldValue).displayValue;
      if (!dateValue) return EM_DASH;
      return formatDate(parseDate(dateValue), 'long');

    case DataFieldType.NUMBER:
      const numberValue = Number((value as FieldValue).displayValue);
      if (!numberValue) return EM_DASH;
      return formatNumber(numberValue);

    case DataFieldType.BOOLEAN:
      if (!(value as FieldValue).displayValue) return EM_DASH;

      return capitalizeWords((value as FieldValue).displayValue.toString());

    default:
      return (value as FieldValue).displayValue || EM_DASH;
  }
};
